<template>
    <div>
        <div v-if="appliedFilter" class="mb-3">
            <span class="h5" :title="`Saved Filter Applied: ${appliedFilter.filter_name}`"><i class="fa fa-filter"></i> {{ appliedFilter.filter_name }}</span>
            -
            <b-button-group size="sm">
                <b-button variant="default" title="Remove Saved Filter" @click="removeFilter()"><i class="fa fa-remove"></i></b-button>
                <template v-if="appliedFilter.UserId == $store.state.user.user_id || $store.state.user.is_admin">
                    <b-button variant="default" title="Update Saved Filter" @click="setUpdateFilter()"><i class="fa fa-edit"></i></b-button>
                    <b-button variant="default" title="Delete Saved Filter" @click="setDeleteFilter()"><i class="fa fa-trash text-danger"></i></b-button>
                </template>
            </b-button-group>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            filterKey: {
                type: String,
                required: true,
            },
        },

        data: function() {
            return {

            }
        },

        watch: {

        },

        computed: {
            appliedFilter(){
                //Send it
                return this.$store.state.appliedFilters[this.filterKey] ? this.$store.state.appliedFilters[this.filterKey] : null;
            },
        },

        methods: {
            setUpdateFilter(){
                //Set it
                this.$store.commit('setUpdateFilter', true);
            },

            setDeleteFilter(){
                //Set it
                this.$store.commit('setDeleteFilter', true);
            },

            removeFilter(){
                //Clear the filter
                this.$store.commit('setAppliedFilter', {key: this.filterKey, filter: null});
            }
        },

        mounted() {

        }
    }
</script>